function handlePinchToZoom(container) {
  const image = container.querySelector(".zoom-image");

  // Track scale, translation, and initial gesture state
  let scale = 1;
  let currentX = 0;
  let currentY = 0;
  let disableTouchMove = false;

  // Will store data on gesture start
  let startDist = 0;
  let startScale = 1;
  let startX = 0;
  let startY = 0;
  let midpoint = { x: 0, y: 0 };

  // For double-tap detection
  let lastTapTime = 0;
  const doubleTapDelay = 300; // ms threshold for double tap

  // Helper: distance between two fingers
  function getDistance(touches) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  // Helper: midpoint between two fingers
  function getMidpoint(touches) {
    return {
      x: (touches[0].clientX + touches[1].clientX) / 2,
      y: (touches[0].clientY + touches[1].clientY) / 2,
    };
  }

  // Set transform on the image
  function updateTransform() {
    image.style.transform = `translate(${currentX}px, ${currentY}px) scale(${scale})`;
  }

  // Reset to the original scale and position
  function resetToOriginal() {
    scale = 1;
    currentX = 0;
    currentY = 0;
    updateTransform();
  }

  // Handle touchstart
  container.addEventListener("touchstart", (e) => {
    if (e.touches.length === 1) {
      // Single finger start
      startX = e.touches[0].clientX - currentX;
      startY = e.touches[0].clientY - currentY;
    } else if (e.touches.length === 2) {
      // Two-finger pinch start
      startDist = getDistance(e.touches);
      midpoint = getMidpoint(e.touches);
      startScale = scale;
    }
  });

  // Handle touchmove
  container.addEventListener("touchmove", (e) => {
    e.preventDefault();

    if (disableTouchMove) return;

    if (e.touches.length === 1) {

      // when image is in original size, don't allow to move
      if (scale === 1) {
        return;
      }

      // Single finger => pan
      currentX = e.touches[0].clientX - startX;
      currentY = e.touches[0].clientY - startY;
      
    } else if (e.touches.length === 2) {
      // Two-finger => pinch
      const dist = getDistance(e.touches);
      scale = startScale * (dist / startDist);

      // If scale goes below 1, reset immediately:
      if (scale < 1) {
        resetToOriginal();
        return;
      }

      // Calculate new translation so the pinch "center" stays under fingers
      const newMidpoint = getMidpoint(e.touches);
      currentX += newMidpoint.x - midpoint.x;
      currentY += newMidpoint.y - midpoint.y;
      midpoint = newMidpoint;
    }

    updateTransform();
  });

  // TOUCH END + DOUBLE TAP DETECTION
  container.addEventListener("touchend", (e) => {
    // Restrict max zoom
    if (scale < 1 || scale == 1) {
      resetToOriginal();
      return;
    }

    if (scale > 4) scale = 4;

    // Disable touchmove for a short time after a single-touch event
    // Because when user pulls his one finger after pinch, it triggers touchmove event
    // Flicking the image
    if (e.touches.length === 1) {
      disableTouchMove = true;

      setTimeout(() => {
        disableTouchMove = false;
      }, 300);
    }

    // Detect double-tap (only relevant if it was a single-touch)
    if (e.changedTouches.length === 1 && e.touches.length === 0) {
      const now = Date.now();
      if (now - lastTapTime < doubleTapDelay) {
        // Double tap => reset
        resetToOriginal();
      }
      lastTapTime = now;
    }
  });

  container.addEventListener("reset-zoom", () => {
    resetToOriginal();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const zoomContainers = document.querySelectorAll(".pinch-zoom-container");
  zoomContainers.forEach((container) => {
    handlePinchToZoom(container);
  });
});
